import { render, staticRenderFns } from "./ChartBtn.vue?vue&type=template&id=1bead79d"
import script from "./ChartBtn.vue?vue&type=script&lang=js"
export * from "./ChartBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports